import React from 'react';
import { DialogControl } from 'spark-core-dx/components';

const DeletePageDialog = ({ isActive, closeDialog, deleteMode = "soft", pageName, onConfirm }) => {
  const isHardDelete = deleteMode === "hard";

  return (
    <DialogControl
      className="dashboard-dialog"
      openDialog={isActive}
      title={isHardDelete ? "Delete Page" : "Hide Page"}
      okText={isHardDelete ? "Delete" : "Hide"}
      onOk={async () => {
        await onConfirm?.();
        closeDialog();
      }}
      onCancel={closeDialog}
    >
      <div className="dialog-text">
        {isHardDelete
          ? `Permanently delete ${pageName ? `"${pageName}"` : "this page"}? This cannot be undone.`
          : `Hide ${pageName ? `"${pageName}"` : "this page"}?`}
      </div>
    </DialogControl>
  );
};

export default DeletePageDialog;
